import { AgxBadge } from '@urbanx/agx.ui-components2'
import { getDueDateBadgeState } from 'utils/tasks'

interface TaskDueDateBadgeProps {
  dueDate: string
  isCompleted: boolean
  completedDate?: Date | string
  missingDateText?: string
}

const TaskDueDateBadge = ({
  dueDate,
  isCompleted,
  completedDate,
  missingDateText,
}: TaskDueDateBadgeProps) => {
  const badge = getDueDateBadgeState(
    dueDate,
    isCompleted,
    completedDate,
    missingDateText
  )

  if (badge.type === 'highlighted') {
    return (
      <AgxBadge
        type="highlighted"
        colour={badge.color}
        size="md"
        text={badge.text}
        highlightText={badge.highlightText}
      />
    )
  }

  return (
    <AgxBadge
      type="colourfill"
      colour={badge.color}
      size="md"
      text={badge.text}
    />
  )
}

export default TaskDueDateBadge
